import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3125c4b7&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=3125c4b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3125c4b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3125c4b7')) {
      api.createRecord('3125c4b7', component.options)
    } else {
      api.reload('3125c4b7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3125c4b7&scoped=true&", function () {
      api.rerender('3125c4b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_recipient/index.vue"
export default component.exports